<script lang="ts">
	import ContentBlock from "@components/content-blocks/ContentBlock.svelte";
	import type { ClassValue } from "svelte/elements";
	import type { ContentBlock as ContentBlockData, SavedContentBlock } from "@core/schema/ContentBlock.js";

	const componentId = $props.id();
	const {
		blocks,
		class: customClass,
		lightboxIdPerBlock = false,
		lightboxId = lightboxIdPerBlock ? undefined : componentId,
	}: {
		blocks: (SavedContentBlock | ContentBlockData)[];
		class?: ClassValue;
		lightboxIdPerBlock?: boolean;
		lightboxId?: string;
	} = $props();
</script>

<div class={["full-width flex flex-col gap-14 md:gap-30", customClass]}>
	{#each blocks as block (block.id)}
		<div class="grid-container">
			<ContentBlock {block} {lightboxId} />
		</div>
	{/each}
</div>
